export default __webpack_public_path__ + "static/media/delete.04213a14.svg";